import React from 'react';

// Changes the URL without a full page reload. App listens for "popstate"
// and re-renders for the new path.
const navigate = (path) => {
    window.history.pushState(null, '', path);
    window.dispatchEvent(new PopStateEvent('popstate'));
    window.scrollTo(0, 0);
};

// Internal link. Plain clicks navigate in-app; modified clicks (new tab, etc.)
// keep the browser's default behavior.
const Link = ({ href, children, ...props }) => {
    const onClick = (event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) {
            return;
        }
        event.preventDefault();
        navigate(href);
    };
    return (
        <a {...props} href={href} onClick={onClick}>
            {children}
        </a>
    );
};

export default Link;
